module.exports = __webpack_public_path__ + "static/media/HOD Motions Explainer Video SCRIPT 4-FINAL_1697633938235.0eb3f283.docx";